/* eslint-disable */
import {
  mapState
} from 'vuex'
// services
import db from '@/services/db'
import eventBus from '@/helpers/event-bus'
// helpers
import utils from '../helpers/utils';




const Loading = {
  template: `<div>Loading...</div>`
}

export default {
  functional: true,
  props: {
    template: String,
    data: {
      type: Object,
      default: () => ({})
    },
    computed: {
      type: Object,
      default: () => ({})
    },
    widgetKey: String
  },
  render(h, vm) {
    try {
      // replace <script> to <script2>
      let regex = /<!--.*?-->|(?:<(\/)?script([ >]))/gm

      if (regex.test(vm.props.template)) {
        vm.props.template = vm.props.template.replace(regex, (chunk) => {
          return chunk.replace('script', 'script2')
        })
      }

      const template = `
        <div class="widgetContent">
          ${vm.props.template}
        </div>
      `

      delete vm.props.data.scopedData

      let scopedData = [
        '$sheets',
        ...Object.keys(vm.props.data),
        ...Object.keys(vm.props.computed)
      ]

      scopedData.splice(scopedData.indexOf('spreadsheets'), 1)

      vm.props.data.scopedData = scopedData

      const dynComponent = {
        template,
        data() {
          return {
            ...vm.props.data,
            eventBus,
            widgetKey: vm.props.widgetKey
          }
        },
        computed: {
          ...vm.props.computed,
          ...mapState([
            '$sheets',
            '$nflData',
            '$profile',
            '$profiles',
            'userId',
            'currentTab',
            'currentDash',
            'fbUserModels',
            'fbTrackModels',
            'dashboardModels'
          ]),
          $FBUserModel () {
            return (model, doNotInitOnAbsence) => {
              try {
                let val = eval(`this.fbUserModels.${model}`) // eslint-disable-line
                if (val === undefined) throw new Error()
                return val
              } catch (err) {
                let val = eval(`vm.props.data.${model}`) || '' // eslint-disable-line
                if (!doNotInitOnAbsence) this.$setFBUserModel(model, val)
              }
              return null
            }
          },
          $getDashboardModel () {
            return utils.assignDashboardModelReader(this.dashboardModels)
          }
        },
        methods: {
          $setFBUserModel(model, val, callback) {
            if (!model) throw new Error('[$setFBUserModel] model key is required')
            let id = this.userId
            db.widgets.setUserModel(id, model, val, callback)
          },
          $setFBTrackModel(model, val, callback) {
          // if (!model) throw new Error('[$addFBTrackModel] model key is required')
            let id = this.userId
            db.setTrackModel(id, model, val, callback)
          },
          readWidget(path) {
            let ref = db.getRef('widgetsData').child(path)
            let val = eval(`vm.props.data.` + path)
            return val
          },
          addItem(path, item) {
            let ref = db.getRef('widgetsData').child(path)
            ref.push(item)
          }
        },
        created() {
          window.$setFBUserModel = this.$setFBUserModel.bind(this)
          window.$setFBTrackModel = this.$setFBTrackModel.bind(this)
          window.$FBUserModel = this.$FBUserModel.bind(this)
          window.$FBTrackModels = this.$can('update', 'Dashboard_' + this.currentDash) ? this.fbTrackModels : null
          window.$nflData = this.$nflData
          window.$profile = this.$profile
          window.$profiles = this.$can('update', 'Dashboard_' + this.currentDash) ? this.$profiles : null
          window.$sheets = this.$sheets
          window.onSpreadsheetUpdate = function (callback) {
            eventBus.$on('onSpreadsheetUpdate', callback)
          }
        },
        beforeDestroy () {
          eventBus.$off('onSpreadsheetUpdate')
        }
      }

      const component = template ? dynComponent : Loading

      return h(component)
    } catch (err) {
      console.error(err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DynamicRender.js